module.exports = __webpack_public_path__ + "static/media/Manishaben.acebe739.png";